import { MouseEventHandler, ReactNode } from "react";
import styles from "./PTab.module.scss";

type PTabTone = "primary" | "loyalty";

type PTabProps = {
  href?: string;
  id: string;
  isActive: boolean;
  onClick: MouseEventHandler<HTMLAnchorElement>;
  tone?: PTabTone;
  icon?: ReactNode;
  children: ReactNode;
};

export const PTab = ({
  href = "#",
  id,
  isActive,
  onClick,
  tone = "primary",
  icon,
  children,
}: PTabProps) => (
  <a
    href={href}
    id={id}
    className={`${styles.p_tab} ${styles[tone]} ${
      isActive ? styles.active : ""
    }`}
    onClick={onClick}
  >
    {icon && (
      <span className={styles.icon} aria-hidden="true">
        {icon}
      </span>
    )}
    {children}
  </a>
);
